var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHipaa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 123,
    viewBox: "0 0 113 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.7845 37.508H86.0913V40.5182H81.7845V37.508Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4055 37.508H66.0986V40.5182H70.4055V37.508Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7179 37.4189H55.0248V40.4291H50.7179V37.4189Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.269 18C96.1688 19.5 77.3688 13.2 56.4688 0C38.4688 14 19.8688 18.1 0.868768 17.1C-0.731238 77.4 20.5688 109.7 56.6688 122.9C93.9688 108.8 115.069 75.1 112.269 18ZM59.7688 86.6L56.6688 79L53.6688 86.7L45.4688 87.3L51.7688 92.6L49.7688 100.6L56.7688 96.3L63.7688 100.6L61.7688 92.6L67.9688 87.2L59.7688 86.6ZM43.9453 50H38.4755V32.5957H43.9453V50ZM77.1354 35.4518V50H82.2374V45.468H85.6714V50H90.7734V35.4518L87.9216 32.6H79.9872L77.1354 35.4518ZM61.4372 50V35.4518L64.289 32.6H72.2234L75.0752 35.4518V50H69.9732V45.468H66.5392V50H61.4372ZM46.1712 32.6V50H51.2842V45.402H56.5175L59.5782 42.3412V35.4518L56.7264 32.6H46.1712ZM22.7447 32.6V50H27.8577V43.785H31.1377V50H36.2397V32.6H31.1377V38.672H27.8577V32.6H22.7447Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHipaa);
export default __webpack_public_path__ + "static/media/Hipaa.3284b28258f70ee5f59a1e4bdb294907.svg";
export { ForwardRef as ReactComponent };